if (!customElements.get('social-media-gallery')) {
  customElements.define(
    'social-media-gallery',
    class SocialMediaGallery extends HTMLElement {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll('[data-social-gallery-open]'));
        this.modal = document.getElementById(this.dataset.modalId);
        if (!this.items.length || !this.modal) return;

        this.modalContent = this.modal.querySelector('[data-social-gallery-content]');
        this.previousButton = this.modal.querySelector('[data-social-gallery-prev]');
        this.nextButton = this.modal.querySelector('[data-social-gallery-next]');
        if (!this.modalContent || !this.previousButton || !this.nextButton) return;

        this.modal.dataset.socialGalleryOwner = this.id;
        this.items.forEach((item, index) => item.addEventListener('click', () => this.open(index, item)));
        this.previousButton.addEventListener('click', () => this.change(-1));
        this.nextButton.addEventListener('click', () => this.change(1));
        this.modal.addEventListener('keydown', (event) => this.onKeydown(event));

        const hideNavigation = this.items.length < 2;
        this.previousButton.hidden = hideNavigation;
        this.nextButton.hidden = hideNavigation;
      }

      disconnectedCallback() {
        if (this.modal?.dataset.socialGalleryOwner === this.id) this.modal.remove();
      }

      open(index, opener) {
        this.activeIndex = index;
        this.renderActiveItem();
        this.modal.show(opener);
      }

      change(direction) {
        if (this.items.length < 2) return;
        this.activeIndex = (this.activeIndex + direction + this.items.length) % this.items.length;
        this.renderActiveItem();
      }

      renderActiveItem() {
        const blockId = this.items[this.activeIndex]?.dataset.blockId;
        const template = this.querySelector(`template[data-social-gallery-template="${blockId}"]`);
        if (!template) return;
        this.modalContent.replaceChildren(template.content.cloneNode(true));
      }

      onKeydown(event) {
        if (event.key === 'ArrowLeft') this.change(-1);
        if (event.key === 'ArrowRight') this.change(1);
      }
    }
  );
}
